export enum InvitationStatus {
  Pending,
  Accepted,
  Cancelled
}
